var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventIssue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "84px",
    height: "84px",
    viewBox: "0 0 84 84",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "telegram\u5907\u4EFD 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPhone-13\\u5907\\u4EFD",
    transform: "translate(-245.000000, -482.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "telegram\\u5907\\u4EFD-7",
    transform: "translate(245.000000, 482.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0,
    y: 0,
    width: 84,
    height: 84
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#5434C9",
    x: 14,
    y: 14,
    width: 56,
    height: 56,
    rx: 10.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(24.500000, 24.500000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3289474,0 C26.0919723,0 26.7105263,0.618553965 26.7105263,1.38157895 L26.7105263,2.7631579 L29.9360527,2.7631579 C32.7342105,2.7631579 35,5.03078945 35,7.8330921 L35,29.9296053 C35,32.7300658 32.7332895,35 29.9360527,35 L5.06394734,35 C2.26578948,35 0,32.7323684 0,29.9300658 L0,7.83355264 C0,5.03309211 2.26671051,2.7631579 5.06394734,2.7631579 L8.28947369,2.7631579 L8.28947369,1.38157895 C8.28947369,0.618553965 8.90802766,0 9.67105264,0 C10.4340776,0 11.0526316,0.618553965 11.0526316,1.38157895 L11.0526316,2.7631579 L23.9473684,2.7631579 L23.9473684,1.38157895 C23.9473684,0.618553965 24.5659224,0 25.3289474,0 Z M20.7236842,22.1052632 L8.74999998,22.1052632 C7.98697499,22.1052632 7.36842103,22.7238171 7.36842103,23.4868421 C7.36842103,24.2498671 7.98697499,24.8684211 8.74999998,24.8684211 L8.74999998,24.8684211 L20.7236842,24.8684211 C21.4867092,24.8684211 22.1052632,24.2498671 22.1052632,23.4868421 C22.1052632,22.7238171 21.4867092,22.1052632 20.7236842,22.1052632 L20.7236842,22.1052632 Z M26.25,15.1973684 L8.74999998,15.1973684 C7.98697499,15.1973684 7.36842103,15.8159224 7.36842103,16.5789474 C7.36842103,17.3419724 7.98697499,17.9605263 8.74999998,17.9605263 L8.74999998,17.9605263 L26.25,17.9605263 C27.013025,17.9605263 27.631579,17.3419724 27.631579,16.5789474 C27.631579,15.8159224 27.013025,15.1973684 26.25,15.1973684 L26.25,15.1973684 Z",
    id: "\\u5F62\\u72B6"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventIssue);
export default __webpack_public_path__ + "static/media/event_issue.f148c8b0351adee7c85879ce36243778.svg";
export { ForwardRef as ReactComponent };